import React, { useEffect, useState } from 'react';
import Form from '~~elements/Form';
import Multilingual from '~~utils/Multilingual';
import IconCircleChecked from '~~elements/static/IconCircleChecked.svg';
import { SectionDiv } from '../styled';

const Plugins = ({ tournament }) => {
  const [plugins, setPlugins] = useState({
    open_registration: false,
    expand_media_space: false,
    paper_record_online: false,
    offline_commissioner: false,
  });

  useEffect(() => {
    setPlugins({
      open_registration: tournament.config.open_registration,
      expand_media_space: tournament.config.expand_media_space,
      paper_record_online: tournament.config.paper_record_online,
      offline_commissioner: tournament.config.offline_commissioner,
    });
  }, [tournament]);

  const purchasedIcon = (key) => {
    if (!plugins[key]) {
      return <input type="checkbox" checked={false} disabled={true} />;
    }

    return <img style={{ width: '2rem', height: '2rem' }} src={IconCircleChecked} alt="bought" />;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <SectionDiv>
      <Form onSubmit={handleSubmit}>
        <div className="box">
          <div className="description">{Multilingual('TOURNAMENT.PLUGIN.CONVINCE_IN_MANAGEMENT')}</div>
          <div className="input-field" />
          {/* 報名系統 */}
          <label>
            {purchasedIcon('open_registration')}
            {Multilingual('TOURNAMENT.PLUGIN.OPEN_REGISTRATION')}
            <i>{Multilingual(`FORM.SUGGEST`)}</i>
          </label>
          <div className="description">{Multilingual('TOURNAMENT.PLUGIN.OPEN_REGISTRATION_DESCRIPTION')}</div>
          <div className="input-field" />
          {/* 花絮擴充 */}
          <label>
            {purchasedIcon('expand_media_space')}
            {Multilingual('TOURNAMENT.PLUGIN.EXPAND_MEDIA_SPACE')}
            <i>{Multilingual(`FORM.SUGGEST`)}</i>
          </label>
          <div className="description">{Multilingual('TOURNAMENT.PLUGIN.EXPAND_MEDIA_SPACE_DESCRIPTION')}</div>
          <div className="input-field" />
          {/* 紙本紀錄上傳 */}
          <label>
            {purchasedIcon('paper_record_online')}
            {Multilingual('TOURNAMENT.PLUGIN.PAPER_RECORD_ONLINE')}
          </label>
          <div className="description">{Multilingual('TOURNAMENT.PLUGIN.PAPER_RECORD_ONLINE_DESCRIPTION_SHORT')}</div>
          <div className="input-field" />
          {/* 線下特派員 */}
          <label>
            {purchasedIcon('offline_commissioner')}
            {Multilingual('TOURNAMENT.PLUGIN.OFFLINE_COMMISSIONER')}
          </label>
          <div className="description">{Multilingual('TOURNAMENT.PLUGIN.OFFLINE_COMMISSIONER_DESCRIPTION_SHORT')}</div>
        </div>
      </Form>
    </SectionDiv>
  );
};

export default Plugins;
